/* eslint-disable no-undef */
import $ from "jquery";

const changeOnInputEmail = () => {
  const init = () => {
    execute();
  };



  const execute = () => {
    const el = {
      emailText: ".woocommerce-ResetPassword.lost_reset_password .js-email-reset-password",
      inputEmail: ".woocommerce-ResetPassword.lost_reset_password #user_login",
    };
    $(function () {
      $(document).on("input", el.inputEmail, function () {
        $(el.emailText).text($(this).val());
      });
    });
  };

  init();
};

try {
  changeOnInputEmail();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
